module.exports = __webpack_public_path__ + "img/logo.bd10d06a.png";